module.exports = __webpack_public_path__ + "img/logo.ac04850f.png";